import {
  ActiveUser,
  PermissionRow,
  User,
  UserEditFormValues,
  UserPermission,
  UserPermissionEditFormValues,
  UserPermissionRow,
  UserRole,
  UserRow,
} from "./types";

/*-----------------------------------------------------------------------
  USER
-------------------------------------------------------------------------*/

export const transformUserRow = (res: any): UserRow => {
  return {
    id: res.id,
    firstName: res.firstName,
    lastName: res.lastName,
    email: res.email,
    phoneNumber: res.phoneNumber,
    mobilePhoneNumber: res.mobilePhoneNumber,
    oib: res.oib,
    userName: res.username,
    addressCity: res.addressCity,
    addressCountry: res.addressCountry,
    addressLine1: res.addressLine1,
    addressLine2: res.addressLine2,
    addressPostalCode: res.addressPostalCode,
    addressState: res.addressState,
    roles: res.roles,
    avatar: res.avatar
  };
};

export const transformActiveUser = (res: any): ActiveUser => {
  return {
    user: res ? transformUser(res) : null,
  };
};

export const transformUser = (res: any): User => {
  return {
    id: res.id,
    firstName: res.firstName,
    lastName: res.lastName,
    email: res.email,
    phoneNumber: res.phoneNumber,
    mobilePhoneNumber: res.mobilePhoneNumber,
    oib: res.oib,
    userName: res.username,
    password: res.password,
    addressCity: res.addressCity,
    addressCountry: res.addressCountry,
    addressLine1: res.addressLine1,
    addressLine2: res.addressLine2,
    addressPostalCode: res.addressPostalCode,
    addressState: res.addressState,
    officeId: res.officeId,
    tenant: res.tenant,
    roles: res.roles,
    avatar: res.avatar
  };
};

export const transformUserCreate = (res: UserEditFormValues): any => ({
  firstName: res.firstName,
  lastName: res.lastName,
  email: res.email,
  phoneNumber: res.phoneNumber,
  mobilePhoneNumber: res.mobilePhoneNumber,
  oib: res.oib,
  userName: res.userName,
  password: res.password,
  addressCity: res.addressCity,
  addressCountry: res.addressCountry,
  addressLine1: res.addressLine1,
  addressLine2: res.addressLine2,
  addressPostalCode: res.addressPostalCode,
  addressState: res.addressState,
  officeId: res.officeId,
  roles: res.roles,
});

export const transformUserUpdate = (res: UserEditFormValues): any => ({
  id: res.id,
  firstName: res.firstName,
  lastName: res.lastName,
  email: res.email,
  phoneNumber: res.phoneNumber,
  mobilePhoneNumber: res.mobilePhoneNumber,
  oib: res.oib,
  userName: res.userName,
  password: res.password,
  addressCity: res.addressCity,
  addressCountry: res.addressCountry,
  addressLine1: res.addressLine1,
  addressLine2: res.addressLine2,
  addressPostalCode: res.addressPostalCode,
  addressState: res.addressState,
  officeId: res.officeId,
  roles: res.roles,
});

/*-----------------------------------------------------------------------
  PERMISSION
-------------------------------------------------------------------------*/

export const transformPermissionRow = (res: any): PermissionRow => {
  // Handle category as object or string
  const category = typeof res.category === 'object' && res.category !== null
    ? res.category.breadcrumb || res.category.name || ''
    : res.category || '';

  return {
    id: res.id,
    code: res.code,
    name: res.name,
    breadcrumb: res.breadcrumb,
    description: res.description,
    category
  };
};

/*-----------------------------------------------------------------------
  USER - PERMISSION 
-------------------------------------------------------------------------*/

export const transformUserPermissionRow = (res: any): UserPermissionRow => {
  return {
    id: res.id,
    name: res.name,
    enabled: res.enabled,
  };
};

export const transformUserPermission = (res: any): UserPermission => {
  return {
    id: res.id,
    name: res.name,
    enabled: res.enabled,
  };
};

export const transformUserPermissionCreate = (
  res: UserPermissionEditFormValues
): any => ({
  name: res.name,
  enabled: res.enabled,
});

export const transformUserPermissionUpdate = (
  res: UserPermissionEditFormValues
): any => ({
  id: res.id,
  name: res.name,
  enabled: res.enabled,
});

/*-----------------------------------------------------------------------
  ROLES
-------------------------------------------------------------------------*/

export const transformUserRoles = (res: any): UserRole => {
  return {
    id: res.id,
    name: res.name,
    isAdmin: res.isAdmin,
    isSystem: res.isSystem
  };
};
